import { FunctionComponent } from "react";
import { StyledBackgroundMesh } from "./background-mesh.styles";

const BackgroundMesh: FunctionComponent<any> = ({ children }) => (
  <StyledBackgroundMesh>{children}</StyledBackgroundMesh>
);

export default BackgroundMesh;
